import { TimeUnit } from 'framework/types/TimeUnit';
import React from 'react';
import { ITimeUnitTranslation } from '../timeUnit/ITimeUnitTranslation';

interface IRecordContext {
    timeUnitRecord: Record<TimeUnit, ITimeUnitTranslation>;
}

export const RecordContext = React.createContext<IRecordContext>(undefined as any);
